import { useNormalizeNestedCell } from './use-normalize-cell';

import { columnsNested } from 'utils/columns-table';

import {
  StyledTableCell,
  StyledTableNestedHead,
  StyledTableNestedRow
} from './grid-table.style';

export const TableNestedHead = () => {
  return (
    <StyledTableNestedHead>
      <StyledTableNestedRow>
        {columnsNested.map(({ title, dataIndex }) => (
          <StyledTableCell key={dataIndex}>{title}</StyledTableCell>
        ))}
      </StyledTableNestedRow>
    </StyledTableNestedHead>
  );
};

const TableNestedCell = ({ item, dataIndex }) => {
  const { cellValue } = useNormalizeNestedCell(item, dataIndex);
  return <StyledTableCell>{cellValue}</StyledTableCell>;
};

export const TableNestedRow = ({ item }) => {
  return (
    <StyledTableNestedRow>
      {columnsNested.map(({ dataIndex }) => (
        <TableNestedCell key={dataIndex} item={item} dataIndex={dataIndex} />
      ))}
    </StyledTableNestedRow>
  );
};
